module.exports = __webpack_public_path__ + "img/lookbook_16_left.5c025d12.png";